import { useEffect, useState, useRef } from 'react';

const testimonials = [
  {
    quote: "I drafted a motion for summary judgment during a 20-minute wait at the courthouse. What used to take three hours took twenty minutes. This is the tool I didn't know I needed.",
    name: "",
    title: "Solo Practitioner · Grand Rapids, MI",
    initials: "MW",
    practice: "Civil Litigation"
  },
  {
    quote: "The zero data retention piece is what sold me. My clients trust me with their most sensitive matters. I'm not going to hand that to a cloud server. HushLegal actually gets attorney-client privilege.",
    name: "",
    title: "Partner · Detroit, MI",
    initials: "JK",
    practice: "Family Law"
  },
  {
    quote: "I dictated a contract on my way back from a client meeting. By the time I got to my office, it was ready to review. At $25 a month I'd feel guilty if I didn't sign up.",
    name: "",
    title: "Criminal Defense · Ann Arbor, MI",
    initials: "DC",
    practice: "Criminal Defense"
  }
];

export default function SocialProof() {
  const [animated, setAnimated] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimated(true);
        }
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative py-16 sm:py-20 lg:py-32 bg-white">
      <div className="max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`text-center mb-12 sm:mb-16 transition-all duration-700 ${animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="font-harvey-sans text-[#8B4513] text-sm font-semibold tracking-widest uppercase mb-3">
            Early Access Members
          </p>
          <h2 className="font-harvey-serif text-[#09090b] text-[28px] sm:text-[38px] lg:text-[48px] font-normal tracking-tight">
            Attorneys who get it
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((t, index) => (
            <div
              key={index}
              className={`relative p-6 sm:p-8 bg-[#f5f0e8] border border-[#e8dcc8] rounded-2xl flex flex-col transition-all duration-700`}
              style={{ transitionDelay: `${index * 150}ms`, opacity: animated ? 1 : 0, transform: animated ? 'translateY(0)' : 'translateY(24px)' }}
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="text-[#d4af37] text-lg">★</span>
                ))}
              </div>

              {/* Quote */}
              <p className="font-harvey-sans text-[#52525b] text-[15px] sm:text-[16px] font-light leading-relaxed mb-6 flex-grow">
                "{t.quote}"
              </p>

              {/* Attribution */}
              <div className="flex items-center gap-3 pt-4 border-t border-[#e8dcc8]">
                <div className="w-10 h-10 rounded-full bg-[#d4af37]/20 border border-[#d4af37]/40 flex items-center justify-center flex-shrink-0">
                  <span className="font-harvey-sans text-[#8B4513] text-xs font-semibold">{t.initials}</span>
                </div>
                <div>
                  {t.name && <p className="font-harvey-sans text-[#09090b] text-sm font-semibold">{t.name}</p>}
                  <p className="font-harvey-sans text-[#71717a] text-xs font-light">{t.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className={`text-center mt-10 sm:mt-12 transition-all duration-700 delay-500 ${animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="font-harvey-sans text-[#71717a] text-sm font-light tracking-wide">
            Attorneys across Michigan are reserving their founder spots. Pricing goes up at launch — no exceptions.
          </p>
        </div>
      </div>
    </section>
  );
}
